/* Custom code here */

$(document).ready(function() {
    $('select[name="id"]').on('change', function() {
        var selectedOption = $(this).find(':selected');
        var attributeValue = selectedOption.attr('data-final__sale'); 
        if(attributeValue == "true") {
            if($(".finalSaleMetafield").hasClass("hidden")) {
                $(".finalSaleMetafield").removeClass("hidden");
            }            
        } else {
            if(!$(".finalSaleMetafield").hasClass("hidden")) {
                $(".finalSaleMetafield").addClass("hidden");
            } 
        }
    });
    
    function hideUnavalable(firstSelected) {
        // Loop through the inputs in data-index="1"
        $('.variant-wrapper[data-index="1"] input[type="radio"]').each(function () {
            var $target = $(this); // Refers to each radio input in data-index="1"
            var selectedValue1 = $target.val();
    
            // Combine the values to check in the select options
            var combination = firstSelected + " / " + selectedValue1;
    
            // Flag to track whether a combination exists
            var combinationExists = false;
    
            // Loop through the select options to find matches
            $('select[data-product-select] option').each(function () {
                var optionText = $(this).text(); // Text of the current option
                if (optionText.includes(combination)) {
                    combinationExists = true;
                    return false; // Break out of the loop
                }
            });
    
            // If combination doesn't exist, add the "unavailable" class
            if (!combinationExists) {
                if (!$target.next('label').hasClass("unavailable")) {
                    $target.next('label').addClass('unavailable');
                }
            } else {
                // If combination exists, remove the "unavailable" class
                if ($target.next('label').hasClass("unavailable")) {
                    $target.next('label').removeClass('unavailable');
                }
            }
        });
    }
    //hide un-available options when it is loaded at the first time
    var selectedInput = $('.variant-wrapper[data-index="0"] input[type="radio"]:checked').val();
    hideUnavalable(selectedInput);
    //hide un-available options when the first options are selected.
    $(document).on('change', '.variant-wrapper[data-index="0"] input[type="radio"]', function () {
        // Get the selected value from data-index="0"
        var selectedValue0 = $(this).val(); // Refers to the radio input that triggered the change
        hideUnavalable(selectedValue0);        
    });
    

});